import moment from "moment";
import { Dialog, InputLabel } from "@mui/material";
import React, { useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomDatePicker from "../../../common/commonComponents/CustomDatePicker";
import { InputLabelStyle } from "../../../common/form-fields-mui/ASelect";
import AAutoComplete from "../../../common/form-fields-mui/AAutoComplete";

import { isFilterApplied } from "../../../edpOps/constant/batch-search";
import { formatDropdown, modeDropdown } from "../../constant/common";
import { useFetchTestTypes } from "../../academicTest/hooks";
import { INITIAL_TEST_FILTERS } from "../editViewTimetable/constant";

const TEST_MEDIUM = [
  {
    label: "Tribyte",
    value: "Tribyte",
  },
  {
    label: "Test Platform",
    value: "Test_Platform",
  },
];

const BranchTestFilter = ({
  isOpenTestFilter,
  setIsOpenTestFilter,
  applyFilter,
  filterMenu,
  setFilterMenu,
  filterCount,
  setFilterCount,
}) => {
  const testTypesDropdown = useFetchTestTypes();
  const [filterForm, setFilterForm] = useState(filterMenu);

  const {
    testMode,
    testFormat,
    resultDate,
    itemTypeDateFrom,
    itemTypeDateTo,
    testType,
    testMedium,
  } = filterForm;

  const handleApplyFilter = () => {
    const filterCount = isFilterApplied({
      ...filterForm,
    });
    setFilterCount(filterCount);

    setFilterMenu(filterForm);

    const testFilter = {
      ...(itemTypeDateFrom && {
        itemTypeDateFrom: new Date(itemTypeDateFrom).toISOString(),
      }),
      ...(itemTypeDateTo && {
        itemTypeDateTo: new Date(
          moment(itemTypeDateTo).endOf("day")
        ).toISOString(),
      }),
      ...(resultDate && {
        resultDate: new Date(resultDate).toISOString(),
      }),

      ...(testMode && {
        testMode: testMode.value,
      }),
      ...(testFormat && {
        testFormat: testFormat.value,
      }),
      ...(testType && {
        testType: testType.label,
      }),
      ...(testMedium && {
        testMedium: testMedium.value,
      }),
    };
    applyFilter({ testFilter });
    setIsOpenTestFilter(false);
  };

  const resetFilterForm = () => {
    setFilterMenu(INITIAL_TEST_FILTERS);
    // setFilterForm(INITIAL_TEST_FILTERS);
    applyFilter({});

    setFilterCount(0);
    setIsOpenTestFilter(false);
  };

  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  return (
    <Dialog
      open={isOpenTestFilter}
      PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
    >
      <Card
        className="mb-0 regular-body label-color"
        style={{ width: "330px", borderRadius: "12px" }}
      >
        <CardBody className="d-flex flex-column">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-bold text-lg mb-2">Filters</div>
            <CrossIcon
              onClick={() => {
                setIsOpenTestFilter(false);
              }}
            />
          </div>

          <div className="d-flex flex-column gap-md">
            <div>
              <InputLabel style={InputLabelStyle}>Date range</InputLabel>
              <Row>
                <Col sm="6">
                  <CustomDatePicker
                    placeHolder="From"
                    minDate={moment()}
                    value={itemTypeDateFrom ? moment(itemTypeDateFrom) : null}
                    handler={(index, date, keyName) => {
                      filterFormHandler("itemTypeDateFrom", date);
                      filterFormHandler("itemTypeDateTo", "");
                    }}
                    // maxDate={moment()}
                  />
                </Col>
                <Col sm="6">
                  <CustomDatePicker
                    placeHolder="To"
                    value={itemTypeDateTo ? moment(itemTypeDateTo) : null}
                    handler={(index, date, keyName) => {
                      filterFormHandler("itemTypeDateTo", date);
                    }}
                    minDate={moment(itemTypeDateFrom)}
                    // maxDate={moment()}
                    disabled={!itemTypeDateFrom}
                  />
                </Col>
              </Row>
            </div>

            <div>
              <InputLabel style={InputLabelStyle}>Result Date</InputLabel>
              <CustomDatePicker
                placeHolder="Select date"
                // minDate={moment()}
                value={resultDate ? moment(resultDate) : null}
                handler={(index, date, keyName) => {
                  filterFormHandler("resultDate", date);
                }}
              />
            </div>

            <AAutoComplete
              // height={inputHeight}
              label="Test Type"
              placeholder="Select"
              items={testTypesDropdown}
              isMulti={false}
              currentValue={testType}
              handleChange={(value) => {
                filterFormHandler("testType", value);
              }}
              inputKey="testType"
            />

            <AAutoComplete
              // height={inputHeight}
              label="Format"
              placeholder="Select"
              items={formatDropdown}
              isMulti={false}
              currentValue={testFormat}
              handleChange={(value) => {
                filterFormHandler("testFormat", value);
              }}
              inputKey="testFormat"
            />

            <AAutoComplete
              // height={inputHeight}
              label="Mode"
              placeholder="Select"
              items={modeDropdown}
              isMulti={false}
              currentValue={testMode}
              handleChange={(value) => {
                filterFormHandler("testMode", value);
              }}
              inputKey="testMode"
            />

            <AAutoComplete
              // height={inputHeight}
              label="Test Medium"
              placeholder="Select"
              items={TEST_MEDIUM}
              isMulti={false}
              currentValue={testMedium}
              handleChange={(value) => {
                filterFormHandler("testMedium", value);
              }}
              inputKey="testMedium"
            />

            <div className="mt-3 d-flex flex-row-reverse justify-content-between">
              <AButton
                variant="primary_filled"
                className="w-full"
                onClick={handleApplyFilter}
                disabled={
                  isFilterApplied({
                    ...filterForm,
                  }) == 0
                }
              >
                Apply filter
              </AButton>

              {filterCount > 0 && (
                <AButton
                  variant="outline"
                  className="button_remove_left_margin"
                  updatedStyle={{
                    border: "1px solid #CC5F5F",
                    color: "#CC5F5F",
                  }}
                  onClick={resetFilterForm}
                >
                  Remove filter
                </AButton>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </Dialog>
  );
};

export default BranchTestFilter;
